import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, HostListener, OnDestroy } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { AccountService } from 'src/app/core/services/account.service';
import { IMenuItem, SharedDataService } from 'src/app/core/services/shared-data.service';
import { User } from './../../core/models/user';
import { CdnImageDirective } from 'src/app/core/directive/cdn-image.directive';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import { environment } from 'src/environments/environment';

export interface Country {
  Code?: string;
  Name?: string;
}

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})

export class MenuComponent implements OnInit, OnDestroy {

  // @ViewChild('stickyMenu') menuElement: ElementRef;

  @ViewChild('menu1') menuElement1: ElementRef;

  sticky: boolean = false;
  elementPosition: any;

  currentUser$: Observable<User>;
  menuItems$: Observable<IMenuItem[]>;
  isMenuCollapsed: boolean = true;
  isCollapsed: boolean = true;
  isLoggedIn: boolean = false;
  IsMobile: boolean = false;
  navbarOpen: boolean = false;
  selectedCountry: boolean = true;
  navWhiteBg: boolean = false;
  showFlag: Country = {
    Code: "India",
    Name: "India"
  }

  showAboutUs: boolean = true;
  showProducts: boolean = true;
  showBook: boolean = true;
  showPartnerDirectory: boolean = true;
  showPartners: boolean = true;
  showExplore: boolean = true;
  showContactDetails: boolean = true;
  showApplication: boolean = true;

  showOnMobile: boolean = false;
  scrollOnMobile: boolean = false;
  isParterLogo: boolean = false;
  partnerLogourl: string = '';
  private partnerLogoSub?: Subscription;
  private triedFallbackFolder: boolean = false;

  constructor(
    private router: Router,
    private accountService: AccountService,
    private sharedDataService: SharedDataService,
    private el: ElementRef,
    private route: ActivatedRoute,
  ) {
    this.checkForMobilBrowser();
    this.menuItems$ = this.sharedDataService.menuItemList$;
    this.sharedDataService.menuItemList$.subscribe(items => {
      this.setMenuItemsVisibility(items);
    })
  }

  checkForMobilBrowser() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.showOnMobile = true;
    } else {
      this.showOnMobile = false;
    }
  }

  setMenuItemsVisibility(menuItems: IMenuItem[]) {
    menuItems.forEach(item => {
      switch (item.Name) {
        case 'AboutUs':
          this.showAboutUs = item.Visible;
          break;
        case 'Products':
          this.showProducts = item.Visible;
          break;
        case 'Book':
          this.showBook = item.Visible;
          break;
        case 'PartnerDirectory':
          this.showPartnerDirectory = item.Visible;
          break;
        case 'Partners':
          this.showPartners = item.Visible;
          break;
        case 'Explore':
          this.showExplore = item.Visible;
          break;
        case 'ContactDetails':
          this.showContactDetails = item.Visible;
          break;
      }
    });
  }

  ngOnInit(): void {
    this.currentUser$ = this.accountService.currentUser$;
    this.checkForMobilBrowser();
    this.sharedDataService.applicationMenuDisplay.subscribe(value => {
      this.showApplication = value;
    });
    // On all pages except globe and signup, header background color is solid
    this.navWhiteBg = !this.isTransparentHeaderRoute;
    this.setupPartnerLogoSubscription();
    this.getPartnerLogo();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.navWhiteBg = !this.isTransparentHeaderRoute;
        this.getPartnerLogo();
      }
    });
  }

  ngAfterViewInit() {
    this.elementPosition = this.menuElement1?.nativeElement?.offsetTop;
  }

  get isGlobePage(): boolean {
    const url = (this.router.url || '').split('?')[0];
    const cleanUrl = url.length > 1 && url.endsWith('/') ? url.slice(0, -1) : url;
    return cleanUrl === '/' || cleanUrl === '' || cleanUrl === '/book-now-pay-later';
  }

  get isSignUpPage(): boolean {
    const url = (this.router.url || '').split('?')[0];
    const cleanUrl = url.length > 1 && url.endsWith('/') ? url.slice(0, -1) : url;
    return cleanUrl === '/assist-journey' || cleanUrl === '/assist-journey/sign-up';
  }

  get isTransparentHeaderRoute(): boolean {
    return this.isGlobePage || this.isSignUpPage;
  }

  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    this.scrollOnMobile = false;
    const windowScroll = window.pageYOffset || document.documentElement.scrollTop || 0;
    this.navWhiteBg = windowScroll > 20;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkForMobilBrowser();
  }

  getCurrentUser() {
    this.accountService.currentUser$.subscribe(user => {
      this.isLoggedIn = !!user;
    }, error => {
    })
  }

  loadAndShowCountryDialog() {

  }

  toggleNavbar() {

  }

  GoToSignout() {
    this.accountService.logout();
    this.router.navigateByUrl('/home');
    this.sharedDataService.setDefaultMenuVisibility();
  }

  changeApplication(val) {
    if (val === "personal") {
      this.router.navigateByUrl('/application/appl/(application:personal)')
    } else if (val == "professional") {
      this.router.navigateByUrl('/application/appl/(application:professional)')
    } else if (val == "uploaddocs") {
      this.router.navigateByUrl('/application/appl/(application:uploaddocs)')
    }
  }

  goToHome() {
    let routeUrl: string = this.router.url;
    if (!routeUrl.includes('application')) {
      this.router.navigateByUrl('/');
    }
  }

  // Reset and purge partner logo state completely
  clearPartnerLogo() {
    this.partnerLogourl = '';
    this.isParterLogo = false;
    this.triedFallbackFolder = false;
    MemoryStorageService.removeItem('partnerLogoDataUrl');
    MemoryStorageService.removeItem('partnerLogoPath');
    try {
      localStorage.removeItem('partnerLogoDataUrl');
      localStorage.removeItem('partnerLogoPath');
    } catch (e) {}
  }

  // Extract consolidator ID from agent details
  getConsolidatorIdFromDetails(agentDetails: any): string {
    if (!agentDetails) return '';
    if (Array.isArray(agentDetails.consolidator) && agentDetails.consolidator.length > 0 && agentDetails.consolidator[0]) {
      return agentDetails.consolidator[0].toString().trim();
    }
    if (typeof agentDetails.consolidator === 'string' && agentDetails.consolidator.trim()) {
      return agentDetails.consolidator.trim();
    }
    if (agentDetails.consolidatorId && agentDetails.consolidatorId.toString().trim()) {
      return agentDetails.consolidatorId.toString().trim();
    }
    const storedConsolidator = MemoryStorageService.getItem('consolidatorId') || (typeof localStorage !== 'undefined' ? localStorage.getItem('consolidatorId') : null);
    if (storedConsolidator && storedConsolidator.trim()) {
      return storedConsolidator.trim();
    }
    return '';
  }

  // Construct consolidator logo URL: CDNpath/assets/logos/INDCR...png (for UAT: logos-uat)
  getConsolidatorLogoUrl(consolidatorId: string, useUatFolder?: boolean): string {
    if (!consolidatorId) return '';
    const cleanId = consolidatorId.trim();
    const cdnBase = (environment.CDN_BaseURL || 'https://mihuruendpoint.azureedge.net/websiteimages').replace(/\/+$/, '');
    const isUatEnv = (useUatFolder !== undefined)
      ? useUatFolder
      : (environment.environmentName === 'uat'
         || (typeof window !== 'undefined' && (window.location.hostname.includes('uat') || window.location.hostname.includes('localhost') || window.location.hostname === '127.0.0.1')));
    const folder = isUatEnv ? 'logos-uat' : 'logos';
    return `${cdnBase}/assets/${folder}/${cleanId}.png`;
  }

  // Reactively listen to accountService.partnerLogo observable
  setupPartnerLogoSubscription() {
    if (this.partnerLogoSub) {
      this.partnerLogoSub.unsubscribe();
    }
    this.partnerLogoSub = this.accountService.partnerLogo.subscribe(newUrl => {
      const targetPath = (newUrl && newUrl.trim()) || MemoryStorageService.getItem('partnerLogoPath') || localStorage.getItem('partnerLogoPath');
      if (targetPath && targetPath.trim() && targetPath.trim().toLowerCase() !== 'null' && targetPath.trim().toLowerCase() !== 'undefined') {
        if (targetPath.startsWith('http://') || targetPath.startsWith('https://') || targetPath.startsWith('data:') || targetPath.startsWith('assets/')) {
          this.triedFallbackFolder = false;
          this.partnerLogourl = targetPath;
          this.isParterLogo = true;
          MemoryStorageService.setItem('partnerLogoDataUrl', targetPath);
          try { localStorage.setItem('partnerLogoDataUrl', targetPath); } catch (e) {}
        } else {
          this.accountService.handleGetImageFromContainer({ "FilePath": targetPath }).subscribe({
            next: (base64) => {
              if (base64 && base64.status === 'success' && base64.fileData) {
                this.partnerLogourl = 'data:image/jpeg;base64,' + base64.fileData;
                this.isParterLogo = true;
                this.triedFallbackFolder = false;
                MemoryStorageService.setItem('partnerLogoDataUrl', this.partnerLogourl);
                MemoryStorageService.setItem('partnerLogoPath', targetPath);
                try {
                  localStorage.setItem('partnerLogoDataUrl', this.partnerLogourl);
                  localStorage.setItem('partnerLogoPath', targetPath);
                } catch (e) {}
              } else {
                this.clearPartnerLogo();
              }
            },
            error: () => {
              this.clearPartnerLogo();
            }
          });
        }
      } else {
        this.clearPartnerLogo();
      }
    });
  }

  // Check and load partner logo with persistence across all subsequent pages and reloads
  getPartnerLogo() {
    // 1. Immediately check cached base64 data URL in memory or local storage
    const cachedDataUrl = MemoryStorageService.getItem('partnerLogoDataUrl') || localStorage.getItem('partnerLogoDataUrl');
    if (cachedDataUrl && cachedDataUrl.trim()) {
      this.partnerLogourl = cachedDataUrl;
      this.isParterLogo = true;
    } else {
      this.clearPartnerLogo();
    }

    // 2. Extract agent ID from active URL query parameters, memory, or storage on ANY page
    let agentId: string | null = null;
    if (typeof window !== 'undefined' && window.location) {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        agentId = urlParams.get('utm_source')
          || urlParams.get('regid')
          || urlParams.get('regId')
          || urlParams.get('RegID')
          || urlParams.get('partnerId')
          || urlParams.get('agentId');
      } catch (e) {}
    }
    if (!agentId) {
      try {
        const urlTree = this.router.parseUrl(this.router.url);
        agentId = (urlTree.queryParams['utm_source']
          || urlTree.queryParams['regid']
          || urlTree.queryParams['regId']
          || urlTree.queryParams['RegID']
          || urlTree.queryParams['partnerId']
          || urlTree.queryParams['agentId']) || null;
      } catch (e) {}
    }
    if (!agentId) {
      agentId = MemoryStorageService.getItem('travelAgentId') || localStorage.getItem('travelAgentId') || null;
    }

    if (agentId) {
      const cleanAgentId = agentId.toString().trim().toUpperCase();
      MemoryStorageService.setItem('travelAgentId', cleanAgentId);
      try { localStorage.setItem('travelAgentId', cleanAgentId); } catch (e) {}

      // Fetch agent details
      this.accountService.getAgentDetails(cleanAgentId).subscribe({
        next: (agentDetails: any) => {
          if (agentDetails && agentDetails.logoUrl && typeof agentDetails.logoUrl === 'string' && agentDetails.logoUrl.trim() && agentDetails.logoUrl.trim().toLowerCase() !== 'null' && agentDetails.logoUrl.trim().toLowerCase() !== 'undefined' && !agentDetails.logoUrl.includes('INDCR00173')) {
            const lUrl = agentDetails.logoUrl.trim();
            this.triedFallbackFolder = false;
            if (lUrl.startsWith('http://') || lUrl.startsWith('https://') || lUrl.startsWith('data:') || lUrl.startsWith('assets/')) {
              this.partnerLogourl = lUrl;
              this.isParterLogo = true;
              MemoryStorageService.setItem('partnerLogoDataUrl', lUrl);
              MemoryStorageService.setItem('partnerLogoPath', lUrl);
              try {
                localStorage.setItem('partnerLogoDataUrl', lUrl);
                localStorage.setItem('partnerLogoPath', lUrl);
              } catch (e) {}
            } else {
              this.accountService.setPartnerLogo(lUrl);
            }
          } else {
            // Partner logo URL not found -> Check if consolidator ID is found (e.g. consolidator: ["INDCR00284"])
            const consolidatorId = this.getConsolidatorIdFromDetails(agentDetails);
            if (consolidatorId) {
              MemoryStorageService.setItem('consolidatorId', consolidatorId);
              try { localStorage.setItem('consolidatorId', consolidatorId); } catch (e) {}
              const consolidatorLogoUrl = this.getConsolidatorLogoUrl(consolidatorId);
              this.triedFallbackFolder = false;
              this.partnerLogourl = consolidatorLogoUrl;
              this.isParterLogo = true;
              MemoryStorageService.setItem('partnerLogoDataUrl', consolidatorLogoUrl);
              MemoryStorageService.setItem('partnerLogoPath', consolidatorLogoUrl);
              try {
                localStorage.setItem('partnerLogoDataUrl', consolidatorLogoUrl);
                localStorage.setItem('partnerLogoPath', consolidatorLogoUrl);
              } catch (e) {}
            } else {
              // Neither custom partner logo nor consolidator logo found
              this.clearPartnerLogo();
            }
          }
        },
        error: () => {
          this.clearPartnerLogo();
        }
      });
    } else {
      const cached = MemoryStorageService.getItem('partnerLogoDataUrl') || localStorage.getItem('partnerLogoDataUrl');
      if (!cached) {
        this.clearPartnerLogo();
      }
    }
  }

  onPartnerLogoError() {
    if (this.partnerLogourl && !this.triedFallbackFolder) {
      this.triedFallbackFolder = true;
      if (this.partnerLogourl.includes('/logos-uat/')) {
        this.partnerLogourl = this.partnerLogourl.replace('/logos-uat/', '/logos/');
        return;
      } else if (this.partnerLogourl.includes('/assets/logos/')) {
        this.partnerLogourl = this.partnerLogourl.replace('/assets/logos/', '/assets/logos-uat/');
        return;
      }
    }
    this.clearPartnerLogo();
  }

  ngOnDestroy(): void {
    if (this.partnerLogoSub) {
      this.partnerLogoSub.unsubscribe();
    }
  }

}
